
import { useSnackbar } from 'notistack';

import { useRecoilValue } from 'recoil';

import { addMonths, addDays } from 'date-fns';

import useAxios from 'library/axios'; 
import { useState } from 'react';
import {IBilling, IBillingDetail, IBillingSearch, IBillingDeliverySearch, IBillingDashboardDate, 
    IBillingDashboardMonth, IFinanceDashboard, IEmployeeBillingDashboard, 
    ICommissionDistribution, IBillingDelivery, 
    ISale} from "../models/Billing";
import { useTranslation  } from 'react-i18next';
import { IPagination, ITextFilterElement } from 'components/ui/BasicTextFilterForm';
import { IResult } from 'library/interface';
import { HeadCell, RowCheckedMode } from 'components/ui/EnhancedTable';

import { isNumber, toNumber } from 'lodash';

import { currentUserSessionAtom } from 'library/store';
import { IGroupBillingBilling } from '../models/GroupBilling';

const _ = () => {

    const axios = useAxios(); 

    //const {requestTypeBusinessApps} = useRecoilValue(currentUserSessionAtom);    

    const createBilling = async (billing: IBilling)  =>       
        await (await axios.post('/api/finance/billing/create', billing)).data;       
        
    const updateBilling = async (billing: IBilling)  =>       
        await (await axios.post('/api/finance/billing/update', billing)).data; 
    
    const getBilling = async (id  : number )  => {
      const {data} = (await axios.get(`/api/finance/billing/get-billing/${id}`));
      return await data;
    }

    const createSale = async (sale: ISale)  =>       
      await (await axios.post('/api/finance/billing/create-sale', sale)).data;     

    const updateSale = async (sale: ISale)  =>       
      await (await axios.post('/api/finance/billing/update-sale', sale)).data;     


    const createBillingDelivery = async (billingDelivery: IBillingDelivery)  =>       
        await (await axios.post('/api/finance/billingDelivery/create', billingDelivery)).data;
    
    const updateBillingDelivery = async (billingDelivery: IBillingDelivery)  =>       
        await (await axios.post('/api/finance/billingDelivery/update', billingDelivery)).data;

    const deliverBillingDetail = async (data: {id: number, deliveryDate: Date})  =>       
        await (await axios.post('/api/finance/billing/deliver-billing-detail', data)).data;
        

    const getBillings = async (criteria: IBillingSearch, pagination?: IPagination) : Promise<IBilling[]> => {
      
      const {statusLevel, startDate, endDate, isMyBillings, paymentLevel, customerName, customerPortable, reference, billingNumber, proformaNumber} = criteria;

      const sStartDate = encodeURIComponent(startDate.toISOString());
      const sEndDate = encodeURIComponent(endDate.toISOString());

      const pageSize = pagination?.pageSize ?? 50;
      const pageNumber = pagination?.pageNumber ?? 1;

      const {data} = (await axios.get(`/api/finance/billing/get-billings?statusLevel=${statusLevel}&customerName=${customerName}` +
        `&isMyBillings=${isMyBillings}&paymentLevel=${paymentLevel}&proformaNumber=${proformaNumber}`+
        `&customerPortable=${customerPortable}&reference=${reference}&billingNumber=${billingNumber}&sStartDate=${sStartDate}&sEndDate=${sEndDate}&pageSize=${pageSize}&pageNumber=${pageNumber}`));
      return await data;
    }

    const getUnpaidBillingsByCustomer = async (customerId: number) : Promise<IBilling[]> => {
            
      const {data} = (await axios.get(`/api/finance/billing/get-unpaid-billings-by-customer?customerId=${customerId}`));
      return await data;
    }

    const getGroupBillingBillings = async (billingId  : number ) : Promise<IGroupBillingBilling[]>  => {
      const {data} = (await axios.get(`/api/finance/billing/get-groupBillingBillings?billingId=${billingId}`));
      return await data;
    }

   const getCommissionDistributionsByBilling = async (billingId  : number ) : Promise<ICommissionDistribution[]>  => {
      const {data} = (await axios.get(`/api/finance/billing/get-commissionDistributions-by-billing?billingId=${billingId}`));
      return await data;
    }
    const evaluateAddedProduct = async (billinAddedProduct: any): Promise<IResult<IBillingDetail>>  =>       
        await (await axios.post('/api/finance/billing/evaluate-added-product', billinAddedProduct)).data; 


    const getBillingsByRegistration = async (registrationId: number) : Promise<IBilling[]> => {
            
      const {data} = (await axios.get(`/api/finance/billing/get-billings-by-registration?registrationId=${registrationId}`));
      return await data;
    }

    const getDayDashboard = async (dateFrom: Date, dateTo: Date) : Promise<IBillingDashboardDate> => {
            
      const sDateFrom = encodeURIComponent(dateFrom.toISOString().split('T')[0]);
      const sDateTo = encodeURIComponent(dateTo.toISOString().split('T')[0]);

      const {data} = (await axios.get(`/api/finance/billing/get-billing-day-dashboard?sDateFrom=${sDateFrom}&sDateTo=${sDateTo}`));
      return await data;
    }

    const getMonthDashboard = async (year: number, month: number) : Promise<IBillingDashboardMonth> => {
      
      const {data} = (await axios.get(`/api/finance/billing/get-billing-month-dashboard?year=${year}&month=${month}`));
      return await data;
    }

    const getFinanceDashboard = async (year: number, month: number) : Promise<IFinanceDashboard> => {
      
      const {data} = (await axios.get(`/api/finance/billing/get-finance-dashboard?year=${year}&month=${month}`));
      return await data;
    }

    const getEmployeeBillingDashboard = async (date: Date) : Promise<IEmployeeBillingDashboard> => {
      
      const sDate = encodeURIComponent(date.toISOString().split('T')[0]);

      const {data} = (await axios.get(`/api/finance/billing/get-employee-billing-dashboard?sDate=${sDate}`));
      return await data;
    }

    const getLastServicesByPerson = async (personId: number) : Promise<{packagingName: string, serviceName: string, issueDate: Date}[]> => {
      
      const {data} = (await axios.get(`/api/finance/billing/get-last-billings-by-person?personId=${personId}`));
      return await data;
    }

    const getBillingDeliveriesByBilling = async (billingId: number, status: string) : Promise<IBillingDelivery[]> => {
      const {data} = (await axios.get(`/api/finance/billing/get-billingDeliveries-by-billing?billingId=${billingId}&status=${status}`));
      return await data;
    }
      
    const getBillingDeliveries = async (criteria: IBillingDeliverySearch, pagination?: IPagination) : Promise<IBillingDelivery[]> => {
      const {startDate, endDate, customerName, deliveryNumber, proforma, billingNumber} = criteria;

      const sStartDate = encodeURIComponent(startDate.toISOString());
      const sEndDate = encodeURIComponent(endDate.toISOString());

      const pageSize = pagination?.pageSize ?? 50;
      const pageNumber = pagination?.pageNumber ?? 1;

      const {data} = (await axios.get(`/api/finance/billingDelivery/get-billingDeliveries?customerName=${customerName}` +
        `&deliveryNumber=${deliveryNumber}&proforma=${proforma}&billingNumber=${billingNumber}&sStartDate=${sStartDate}&sEndDate=${sEndDate}&pageSize=${pageSize}&pageNumber=${pageNumber}`));
      return await data;

      
    }

    return {    
      createBilling,
      updateBilling,

      createSale,
      updateSale,

      createBillingDelivery,
      updateBillingDelivery,

      deliverBillingDetail,

      getBilling,
      getBillings,
      getUnpaidBillingsByCustomer,

      getGroupBillingBillings,

      getCommissionDistributionsByBilling,

      evaluateAddedProduct,
      
      getBillingsByRegistration,

      getDayDashboard,
      getMonthDashboard,
      getFinanceDashboard,

      getEmployeeBillingDashboard,

      getLastServicesByPerson,
      getBillingDeliveriesByBilling,
      getBillingDeliveries
    } 
}

export default _;

export interface IFilterBillingOption {
  rowCheckedMode: RowCheckedMode,
  stateSelected?: [number[], React.Dispatch<React.SetStateAction<number[]>>],
  stateFiltered?: [IBilling[], React.Dispatch<React.SetStateAction<IBilling[]>>],
}

const defaultFilterProductOption: IFilterBillingOption = {
  rowCheckedMode: 'single'
  //stateSelected: navigate
}


export const useBasicFilterBilling = (  onRowDoubleClick: (event: React.MouseEvent<unknown>, row: IBilling) => void,
                                            filterOption?: IFilterBillingOption  ) => {

  const { getBillings } = _();

  const { t, i18n } = useTranslation();   

  const {language: lg, applicationSetup } = useRecoilValue(currentUserSessionAtom);

  //const {schoolYears} = useRecoilValue(currentUserSessionAtom);

  const {rowCheckedMode, stateSelected, stateFiltered} = filterOption || defaultFilterProductOption;

  const [headBillingCells, setHeadBillingCells]  = useState<HeadCell<IBilling>[]>([
    {id:'id', label : t('Id'),  display: true, type: 'numeric',  width: 5},
   
    // {id:lg.includes('en')?'customerFirstName':'customerLastName', label : lg.includes('en')?t('First name'):t('Last name'),  display: true, type: 'string'},
    // {id:lg.includes('en')?'customerLastName':'customerFirstName', label : lg.includes('en')?t('Last name'):t('First name'),  display: true, type: 'string'},

    // {id:'customerCorporationName', label : t('Name'),  display: true, type: 'string', },

    {id:'customerName', label : t('Name'),  display: true, type: 'string', width: 35},

    //{id:'customerPortable1', label : t('Portable'),  display: true, type: 'string', width: 8, },

    {id:'reference', label : t('Reference'),  display: true, type: 'string', width: 10, },
    {id:'proformaNumber', label : t('Proforma number'),  display: true, type: 'string', width: 10 },
    {id:'billingNumber', label : t('Billing number'),  display: true, type: 'string', width: 10 },

    {id:'amount', label : t('Amount'),  display: true, type: 'numeric', width: 10, },

    {id: 'status', label: t('Status'), display: true, type: 'expression', width: 10,
      getExpressionNode: (row: IBilling, cellId: keyof IBilling) => {
          switch(row.status) {
            case '95': return t('Not validated');
            case '85': return t('Not validated cancelled');
            case '10': return t('Validated');
            case '80': return t('Cancelled');
            default: return '....';
          } }},    
    {id:'issueDate', label : t('Date'),  display: true, type: 'date',width: 10 },
  ]); 
  const [filterElements,] = useState<ITextFilterElement[]>( [
    {name: 'statusLevel', text: `${t('Status')}-${t('Level')}`, value: '00' , dataType: 'enumeration', 
      options: [ 
                 {name: `${t('Current')} (${t('Validated')} / ${t('Not validated')})`, value: '00'},
                 {name: t('Not validated'), value: '95'},
                 {name: t('Validated'), value: '10'},
                 {name: t('Cancelled'), value: '80'},
                 {name: t('Not validated cancelled'), value: '85'},
                 {name: t('All'), value: '_'}, 
                ]
      },
    
    {name: 'startDate', text: t('Start date'), dataType: 'date' ,  value: '', dateValue: new Date()},
    {name: 'endDate', text: t('End date'), dataType: 'date'  , value: '', dateValue: new Date()},

    {name: 'paymentLevel', text: `${t('Status')}-${t('Payment')}`, value: '00' , dataType: 'enumeration', 
      options: [ 
                 {name: `${t('ALL')}`, value: '00'},
                 {name: t('Unpaid'), value: '95'},
                 {name: t('Partialy paid'), value: '10'},
                 {name: t('Paid'), value: '90'},                  
                ]
      },
    
    {name: 'isMyBillings', text: t('My sales / billings'), value: '', dataType: 'boolean', boolValue: false}, 

    {name: 'customerName', text: t('Customer'), value: ''}, 
    {name: 'customerPortable', text: t('Portable'), value: ''}, 

    {name: 'reference', text: t('Reference'), value: ''},     
    {name: 'billingNumber', text: t('Billing N°'), value: ''},  
    {name: 'proformaNumber', text: t('Init/Prof. N°'), value: ''},  
    ]);    

  const [filteredBillings, ] = useState<IBilling[]>([]); 

  const onFilterButtonClick = async (filterElements: ITextFilterElement[], pagination?: IPagination) : Promise<IBilling[]> => {
    
    const statusLevel = filterElements.find( elt => elt.name === 'statusLevel')?.value || '00';

    const startDate = filterElements.find( elt => elt.name === 'startDate')?.dateValue || new Date();
    const endDate = filterElements.find( elt => elt.name === 'endDate')?.dateValue || new Date();

    const isMyBillings = filterElements.find( elt => elt.name === 'isMyBillings')?.boolValue || false;
    const paymentLevel = filterElements.find( elt => elt.name === 'paymentLevel')?.value || '';

    const customerName = filterElements.find( elt => elt.name === 'customerName')?.value || '';
    const customerPortable = filterElements.find( elt => elt.name === 'customerPortable')?.value || '';
   
    const reference = filterElements.find( elt => elt.name === 'reference')?.value || '';
    const billingNumber = filterElements.find( elt => elt.name === 'billingNumber')?.value || '';
    const proformaNumber = filterElements.find( elt => elt.name === 'proformaNumber')?.value || '';      

    const arr = await getBillings( {statusLevel, startDate, endDate, isMyBillings, paymentLevel,
         customerName,customerPortable, reference, billingNumber, proformaNumber}, pagination );
    
    return arr;
  }

  const objKey: keyof IBilling = 'id';

  const keyProformaNumber : keyof IBilling = 'proformaNumber';
  const keyBillingNumber : keyof IBilling = 'billingNumber';

  return {
    title: t('Teller operation'), headCells: headBillingCells, objKey, 
      keyLinks: [keyProformaNumber, keyBillingNumber], autoFilter: true,
    filterElements, rows: filteredBillings, 
    onFilterButtonClick, onRowDoubleClick, rowCheckedMode, stateSelected, stateFiltered
  }
}



export interface IFilterBillingDeliveryOption {
  rowCheckedMode: RowCheckedMode,
  stateSelected?: [number[], React.Dispatch<React.SetStateAction<number[]>>],
  stateFiltered?: [IBillingDelivery[], React.Dispatch<React.SetStateAction<IBillingDelivery[]>>],
}

const defaultFilterBillingDeliveryOption: IFilterBillingDeliveryOption = {
  rowCheckedMode: 'single'
  //stateSelected: navigate
}


export const useBasicFilterBillingDelivery = (  onRowDoubleClick: (event: React.MouseEvent<unknown>, row: IBillingDelivery) => void,
                                            filterOption?: IFilterBillingDeliveryOption  ) => {

  const { getBillingDeliveries } = _();

  const { t, i18n } = useTranslation();   

  //const {schoolYears} = useRecoilValue(currentUserSessionAtom);

  const {rowCheckedMode, stateSelected, stateFiltered} = filterOption || defaultFilterBillingDeliveryOption;



  const [headBillingDeliveryCells, setHeadBillingDeliveryCells]  = useState<HeadCell<IBillingDelivery>[]>([
    {id:'id', label : t('Id'),  display: true, type: 'numeric', },
    {id:'deliveryNumber', label : t('Delivery number'),  display: true, type: 'string', },
    
    {id:'firstName', label : t('Last name'),  display: true, type: 'string', },
    {id:'lastName', label : t('Last name'),  display: true, type: 'string', },
    {id:'corporationName', label : t('Name'),  display: true, type: 'string', },
    {id:'proformaNumber', label : t('Proforma'),  display: true, type: 'string', },
    {id:'billingNumber', label : t('Billing number'),  display: true, type: 'string', },

    // {id:'amount', label : t('Amount'),  display: true, type: 'numeric', },
        
    {id:'deliveryDate', label : t('Delivery date'),  display: true, type: 'date', },
    {id:'issueDate', label : t('Issue date'),  display: true, type: 'date', },
  ]); 
  const [filterElements,] = useState<ITextFilterElement[]>( [
    
    {name: 'startDate', text: t('Start date'), dataType: 'date' ,  value: '', dateValue: addMonths(new Date(), -1)},
    {name: 'endDate', text: t('End date'), dataType: 'date'  , value: '', dateValue: new Date()},

    {name: 'customerName', text: t('Customer'), value: ''}, 

    {name: 'deliveryNumber', text: t('Delivery number'), value: ''}, 
   
    {name: 'proforma', text: t('Proforma'), value: ''},     
    {name: 'billingNumber', text: t('Billing number'), value: ''},     
      
    ]);    

  const [filteredBillingDeliveries, ] = useState<IBilling[]>([]); 

  const onFilterButtonClick = async (filterElements: ITextFilterElement[], pagination?: IPagination) : Promise<IBillingDelivery[]> => {
    
    const startDate = filterElements.find( elt => elt.name === 'startDate')?.dateValue || new Date();
    const endDate = filterElements.find( elt => elt.name === 'endDate')?.dateValue || new Date();

    const customerName = filterElements.find( elt => elt.name === 'customerName')?.value || '';
    const deliveryNumber = filterElements.find( elt => elt.name === 'deliveryNumber')?.value || '';
   
    const proforma = filterElements.find( elt => elt.name === 'proforma')?.value || '';
    const billingNumber = filterElements.find( elt => elt.name === 'billingNumber')?.value || '';
          
    const arr = await getBillingDeliveries( {startDate, endDate,customerName,deliveryNumber, proforma,billingNumber}, pagination );
    
    return arr;
  }

  const objKey: keyof IBilling = 'id';

  return {
    title: t('Teller operation'), headCells: headBillingDeliveryCells, objKey,
    filterElements, rows: filteredBillingDeliveries, 
    onFilterButtonClick, onRowDoubleClick, rowCheckedMode, stateSelected, stateFiltered
  }
}